import { subscribeWithSelector } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { StateCreator } from 'zustand/vanilla';

import { createDevtools } from '../middleware/create-devtools';
import { type UserState, initialState } from './user-initial-state';
import { type UserAuthAction, createAuthSlice } from './slices/auth/action';

export type UserStore = UserState & UserAuthAction;

const createStore: StateCreator<UserStore, [['zustand/devtools', never]]> = (...parameters) => ({
  ...initialState,
  ...createAuthSlice(...parameters),
});

const devtools = createDevtools('user');

export const useUserStore = createWithEqualityFn<UserStore>()(
  subscribeWithSelector(devtools(createStore)),
  shallow
);

export const getUserStoreState = () => useUserStore.getState();
